"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = require("ramda");

var _blockquote = _interopRequireDefault(require("./blockquote"));

var _cta = _interopRequireDefault(require("./cta"));

var _footnote = _interopRequireDefault(require("./footnote"));

var _html = _interopRequireDefault(require("./html"));

var _image = _interopRequireDefault(require("./image"));

var _intro = _interopRequireDefault(require("./intro"));

var _related = _interopRequireDefault(require("./related"));

var _youtube = _interopRequireDefault(require("./youtube"));

var _brightcove = _interopRequireDefault(require("./brightcove"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RenderHtmlComponent = function RenderHtmlComponent(props, id) {
  if (props === void 0) {
    props = {};
  }

  var COMPONENT_MAP = {
    blockquote: /*#__PURE__*/_react["default"].createElement(_blockquote["default"], _extends({}, props, {
      key: id
    })),
    brightcove: /*#__PURE__*/_react["default"].createElement(_brightcove["default"], _extends({}, props, {
      key: id
    })),
    cta: /*#__PURE__*/_react["default"].createElement(_cta["default"], _extends({}, props, {
      key: id
    })),
    footnote: /*#__PURE__*/_react["default"].createElement(_footnote["default"], _extends({}, props, {
      key: id
    })),
    html: /*#__PURE__*/_react["default"].createElement(_html["default"], _extends({}, props, {
      key: id
    })),
    image: /*#__PURE__*/_react["default"].createElement(_image["default"], _extends({}, props, {
      key: id
    })),
    intro: /*#__PURE__*/_react["default"].createElement(_intro["default"], _extends({}, props, {
      key: id
    })),
    list: /*#__PURE__*/_react["default"].createElement(_related["default"], _extends({}, props, {
      key: id
    })),
    supplemental: /*#__PURE__*/_react["default"].createElement(_related["default"], _extends({}, props, {
      key: id
    })),
    youtube: /*#__PURE__*/_react["default"].createElement(_youtube["default"], _extends({}, props, {
      key: id
    }))
  };
  return COMPONENT_MAP[(0, _ramda.prop)("type", props)] || /*#__PURE__*/_react["default"].createElement("div", {
    key: id
  });
};

RenderHtmlComponent.displayName = "Modules.RenderHtmlComponent";
var _default = RenderHtmlComponent;
exports["default"] = _default;